/** DEV OPTS*/
/* @flow */

/* eslint-env node*/
/* eslint-disable no-console */
/*
 * Coach Amigo React Native App
 * https://github.com/facebook/react-native
 *
 */
import type { Props } from './../types/types';

import * as React from 'react';
import View from './View';
import Touchable from './Touchable';

import Icon from './../utils/Icon';
import { getColor } from './../utils/Colors';
import { rem } from './WebComponents';

const IconButton = (props: Props) => {
   if (!props) props = {};

   props = {
      onPress: null,
      name: 'Star',
      type: 'ionicon',
      iconColor: getColor.rgb('$gray-darkest'),
      colorActive: 'rgba(0,0,0,0.05)',
      color: 'rgba(0,0,0,.04)',
      size: rem(3),
      containerClassName: null,
      iconSize: null,
      containerStyle: null,
      iconStyle: null,
      ...props
   };

   const [state, setState] = React.useState({
      pressIn: false
   });

   let backgroundColor = props.color ? props.color : 'transparent';

   const innerView = (
      <View className={'view ' + (props.containerClassName?props.containerClassName:'')} style={{ width: props.size, height: props.size, alignItems: 'center', justifyContent: 'center', overflow: 'hidden', borderRadius: props.size / 2, backgroundColor: backgroundColor }}>
         <Icon className={'view icon'} name={props.name} type={props.type} color={props.iconColor} size={!props.iconSize ? props.size * 0.6 : props.iconSize} style={props.iconStyle} />
      </View>
   );

   if (!props.onPress) {
      return (
         <View className={'icon-button disabled'} style={props.containerStyle}>
            {innerView}
         </View>
      );
   }

   const onPressIn = () => {
      setState({ pressIn: true });
   };
   const onPressOut = () => {
      setState({ pressIn: false });
   };
   const onPress = (e: Event) => {
      setState({ pressIn: false });
      if (props.onPress) props.onPress(e);
   };

   if (props.onPress && state.pressIn) backgroundColor = props.colorActive;
   return (
      <Touchable className={'touchable icon-button'} activeOpacity={props.onPress ? 0.4 : 1} onPressIn={onPressIn} onPressOut={onPressOut} onPress={onPress} style={{ borderRadius: props.size / 2, ...props.containerStyle }}>
         {innerView}
      </Touchable>
   );
};

export default React.memo(IconButton);
